import _ from "lodash";
import { NotificationManager } from "react-notifications";
import { Types } from "../actions/payrollActions";

import { addWeeks, format, startOfWeek } from "date-fns";
import { v4 as uuidv4 } from "uuid";

const defaultState = {
	payroll: {},
};

const calculateAllowanceAmount = ({ state, input, allowanceType, baseHourlyRate, salaryAllowanceAmount }) => {
	if (Array.isArray(allowanceType)) {
		allowanceType = String(allowanceType[0]);
	}

	let calculation = `${input}`;

	// 1. get type method
	let allowance = _.find(
		[...state.allowances.allowanceList, ...(state.company.settings?.allowances || [])],
		({ id }) => id == allowanceType,
	);
	let method = allowance?.method || (allowance?.overtimeType ? "Hourly" : "Cash");

	// if (!allowance){
	//   let allowance = _.find([...state.allowances.allowanceList,...(state.company.settings?.allowances || [])],{id: allowanceType})
	// }

	if (!allowance) {
		allowance = _.find(state.company.settings.overtimes, ({ id }) => id == allowanceType);

		if (allowance) {
			allowance.isOvertime = true;
			allowance.method = "Hourly";
			method = "Hourly";
		}
	}

	//   console.log('TEST!@#',input,
	// 'type',allowanceType,
	// 'list',state.company.settings?.allowances,
	// 'hours',baseHourlyRate,
	// 'allowance',allowance,
	// 'salaryAllowanceAmount',salaryAllowanceAmount)

	let amount = input == "" ? 0 : parseFloat(input);

	// TODO factor for salary allowances which require multipler factor to be filled in
	if (method == "Multiplier") {
		amount *= (allowance?.multiplier || 1) * (salaryAllowanceAmount || 1);
		calculation = ` * (${allowance?.multiplier || 1} * ${salaryAllowanceAmount || 1})`;
		if (method == "Commission") {
			amount /= 100;
			calculation += ` / 100`;
		}
	}

	if (["Deduction" ,"Foreign Tax Relief"].includes(method)) {
		amount *= -1;
		calculation += ` * -1`;
	}

	if (method == "Commission") {
		amount *= (salaryAllowanceAmount || 1) / 100;
		calculation += ` * ${salaryAllowanceAmount || 1}%`;
	}

	const remainder = (amount * 100) % 100;

	if (method == "Basic") {
		if (remainder == 33) {
			// for rounding
			amount += 0.00333;
		}
		if (remainder == 66) {
			// for rounding
			amount += 0.006667;
		}
		if (remainder == 67) {
			// for rounding
			amount -= 0.01;
			amount += 0.006667;
		}

		if (salaryAllowanceAmount) {
			amount *= salaryAllowanceAmount || 1;
			calculation += ` * ${salaryAllowanceAmount}`;
		} else {
			amount *= baseHourlyRate;
			calculation += ` * ${baseHourlyRate}`;
		}
	}

	if (method == "Hourly") {
		if (remainder == 33) {
			// for rounding
			amount += 0.00333;
		}
		if (remainder == 66) {
			// for rounding
			amount += 0.006667;
		}
		if (remainder == 67) {
			// for rounding
			amount -= 0.01;
			amount += 0.006667;
		}

		if (!salaryAllowanceAmount) {
			amount *= (allowance?.multiplier || 1) * (allowance?.rate || 1) * baseHourlyRate;
			calculation += ` ${allowance?.multiplier ? `* ${allowance?.multiplier}` : ``}${
				allowance?.rate ? ` * ${allowance?.rate}` : ``
			} * ${baseHourlyRate}`;
		} else {
			amount *= (allowance?.multiplier || 1) * (allowance?.rate || 1) * salaryAllowanceAmount;
			calculation += ` ${allowance?.multiplier ? `* ${allowance?.multiplier}` : ``}${
				allowance?.rate ? ` * ${allowance?.rate}` : ``
			} * ${salaryAllowanceAmount}`;
		}
	}

	return {
		amount: parseFloat(amount).toFixed(2),
		calculation,
	};
};

const payrollRecuders = (state, action) => {
	switch (action.type) {
		case Types.PAYROLL_REOPEN_MODAL: {
			let newState = _.cloneDeep(state);
			newState.payroll.reopenPayrollModalOpen = action.open;
			return newState;
		}
		case Types.PAYROLL_CLEAR_PAYSLIP_MODAL: {
			let newState = _.cloneDeep(state);

			newState.payroll.clearPayslipModal = action.employee;

			return newState;
		}
		case Types.PAYROLL_CLEARING_PAYSLIP: {
			let newState = _.cloneDeep(state);

			newState.payroll.clearingPayslip = action.employeeID;

			return newState;
		}
		case Types.PAYROLL_CLEAR_STATE: {
			let newState = _.cloneDeep(state);

			newState.payroll = {
				reopenPayrollModalOpen: false,
				payrollPage: "main",
				generatingReports: false,
				departmentExpanded: {},
				payPeriodDetails: false,
				generating: {
					all: false,
				},
			};

			return newState;
		}
		case Types.PAYROLL_CLEARED_PAYSLIP: {
			let newState = _.cloneDeep(state);

			newState.payroll.clearingPayslip = false;
			newState.payroll.clearPayslipModal = false;

			return newState;
		}
		case Types.PAYROLL_CHANGE_PERIOD_START: {
			let newState = _.cloneDeep(state);

			newState.payroll.resetPeriodStartModal = action.date ? action.date : undefined;

			return newState;
		}
		case Types.PAYROLL_PREVIEW_PAYSLIP: {
			let newState = _.cloneDeep(state);

			if (!newState.payroll.payslipGenerating) {
				newState.payroll.payslipGenerating = {};
			}
			newState.payroll.payslipGenerating[action.id] = action.status;

			return newState;
		}
		case Types.PAYROLL_UPDATE_CHECKLIST_TOGGLE: {
			let newState = _.cloneDeep(state);

			const prevChecked = newState.payroll?.payPeriodDetails?.checklist || {};

			const newChecked = {
				...prevChecked,
				[action.key]: prevChecked[action.key] ? false : true,
			};

			newState.payroll.payPeriodDetails.checklist = {
				...prevChecked,
				...newChecked,
			};

			return newState;
		}
		case Types.PAYROLL_GENERATING_REPORTS: {
			let newState = _.cloneDeep(state);

			if (action.id) {
				newState.payPeriods.updating = {
					...newState.payPeriods.updating,
					[action.id]: action.status,
				};
				if (!action.status) delete newState.payPeriods.updating[action.id];
				return newState;
			}

			newState.payroll.generatingReports = action.status;

			return newState;
		}
		case Types.PAYROLL_PAGE_TOGGLE: {
			let newState = _.cloneDeep(state);

			newState.payroll.payrollPage = action.page;

			return newState;
		}
		case Types.PAYROLL_LAST_PAY_PERIOD: {
			let newState = _.cloneDeep(state);

			newState.payroll.lastPayPeriod = action.payPeriod.payPeriodDetails;

			return newState;
		}
		case Types.PAYROLL_TOGGLE_EMPLOYEE_EXPAND: {
			// let newState = _.cloneDeep(state);
			let newState = { ...state };

			const employeeID = action.employeeID;

			const employeeIndex = newState.payroll.employees.findIndex(({ id }) => id == employeeID);
			const employee = { ...newState.payroll.employees.find(({ id }) => id == employeeID) };

			employee.expand = !employee.expand;

			newState.payroll.employees[employeeIndex] = employee;

			return newState;
		}
		case Types.PAYROLL_NOTE: {
			// let newState = _.cloneDeep(state);
			let newState = { ...state };

			const employeeID = action.employeeID;

			const employeeIndex = newState.payroll.employees.findIndex(({ id }) => id == employeeID);
			const employee = { ...newState.payroll.employees.find(({ id }) => id == employeeID) };

			employee.note = action.note;
			employee.toAdvisor = action.toAdvisor;

			newState.payroll.employees[employeeIndex] = employee;

			return newState;
		}
		case Types.PAYROLL_GENERATING_PAYSLIP: {
			let newState = { ...state };
			const { agreementID } = action;

			const employeeIndex = newState.payroll.employees.findIndex(({ id }) => id == agreementID);
			const employee = { ...newState.payroll.employees.find(({ id }) => id == agreementID) };

			employee.generating = true;
			employee.error = false;

			newState.payroll.employees[employeeIndex] = employee;

			return newState;
		}
		case Types.PAYROLL_ERROR_PAYSLIP: {
			let newState = { ...state };
			const { agreementID } = action;

			const employeeIndex = newState.payroll.employees.findIndex(({ id }) => id == agreementID);
			const employee = { ...newState.payroll.employees.find(({ id }) => id == agreementID) };

			employee.generating = false;
			employee.error = true;

			newState.payroll.employees[employeeIndex] = employee;

			NotificationManager.error(`Problem encountered saving a payslip`, "Error");
			return newState;
		}
		case Types.PAYROLL_SAVE_PAYSLIP: {
			let newState = { ...state };
			// let newState = _.cloneDeep(state);

			const newPayslip = action.payload;

			// console.log('newPayslip.ready',newPayslip.ready)

			// if no entry and not ready this has been saved without recalculating
			if (!newPayslip && !action.ready) {
				const employeeIndex = newState.payroll.employees.findIndex(({ id }) => id == action.agreement);
				const employee = { ...newState.payroll.employees.find(({ id }) => id == action.agreement) };

				// employee.payslip.ready = newPayslip.ready;
				employee.payslip = newPayslip;
				employee.generating = false;
				employee.error = false;

				// console.log('employee.payslip',employee.payslip)

				newState.payroll.employees[employeeIndex] = employee;

				return newState;
			}
			// console.log('newPayslip.ready',newPayslip.ready)

			const savedAllowances = newPayslip.allowances;

			// console.log('action.payload',action.payload)
			// console.log('entry',entry)
			// console.log('savedAllowances',savedAllowances)

			if (!newPayslip) {
				NotificationManager.error(`Problem encountered saving payslip`, "Error");
				return;
			}

			const agreementID = newPayslip.agreementId;
			// console.log('agreementID',agreementID)

			const employeeIndex = newState.payroll.employees.findIndex(({ id }) => id == agreementID);
			const employee = { ...newState.payroll.employees.find(({ id }) => id == agreementID) };
			// console.log('PAYROLL_SAVE_PAYSLIPemployee',employee)
			employee.generating = false;

			if (!!newPayslip.errors?.length) {
				// todo cater for errors
				newPayslip?.errors?.map((error) => {
					NotificationManager.error(error, "Error");
				});
			} else if (newPayslip.net < 0) {
				employee.error = true;
				NotificationManager.error(`Payment due for payslip is lower than 0`, "Error");
			} else {
				employee.error = false;
			}

			if (!employee.payslip) {
				employee.payslipId = newPayslip.id;
			}
			employee.payslip = newPayslip;

			// employee.payslip.baseSalary = baseSalary
			// employee.payslip.basicHours = basicHours
			// employee.payslip.net = net
			// employee.payslip.taxable = taxable
			// employee.payslip.gross = gross;
			// employee.payslip.ready = ready;

			// we may not always have allowances
			savedAllowances.forEach((allowance) => {
				const allowanceId = allowance.id;

				// todo cater for new allowances that require replacing the temporary uuid

				// const employeeAllowance = _.find(employee.allowances,{id: allowanceId})
				let employeeAllowance = employee?.allowances?.find(({ id }) => id == allowanceId);

				if (!employeeAllowance) {
					employee?.allowances?.find(({ allowanceType }) => allowanceType == allowance.allowanceType);
				}

				console.log("employeeAllowance", employeeAllowance, employee.allowances, allowanceId);
				if (employeeAllowance) {
					Object.keys(allowance).map((key) => {
						employeeAllowance[key] = allowance[key];
					});
					employeeAllowance.id = allowanceId;
				} else {
					// new allowance here
					// TODO test this scenario
					if (!employee.allowances) {
						employee.allowances = [];
					}

					const allowanceToAdd = {
						id: allowanceId,
						allowanceType: allowance.allowanceType,
						name: allowance.name,
						calculation: allowance.calculation,
						attachmentOfEarnings: allowance.attachmentOfEarnings,
					};

					Object.keys(allowance).map((key) => {
						allowanceToAdd[key] = allowance[key];
					});

					if (!allowance.input) {
						allowanceToAdd.input = allowance.hours ? allowance.hours : allowance.amount;
					}
					allowanceToAdd.amount = allowance.amount;

					employee.allowances.push(allowanceToAdd);
				}
			});

			// filter out any allowances that are no longer in the payslip (eg net?)
			employee.allowances = employee?.allowances?.filter(({ id }) => savedAllowances.find(({ id: savedId }) => id == savedId));

			// ensure we are creating a new object
			employee.taxes = (employee.taxes && [...employee.taxes]) || [];

			employee.taxes =
				employee.taxes?.map((employeeTax) => ({
					...employeeTax,
					employeeContribution: 0,
					employerContribution: 0,
					employerBreakdown: [],
					employeeBreakdown: [],
					employerCalculation: [],
					employeeCalculation: [],
				})) || [];

			newPayslip.taxes.map((tax) => {
				const taxName = `${tax.taxVariable.taxName}${
					tax.taxVariable.taxCategory ? ` ${tax.taxVariable.taxCategory}` : ``
				}`;

				const employeeContribution = ["Both", "Employee"].includes(tax.taxVariable.payer) ? tax.amount : 0;
				const employerContribution = ["Both", "Employer"].includes(tax.taxVariable.payer) ? tax.amount : 0;
				const employeeBreakdown = ["Both", "Employee"].includes(tax.taxVariable.payer)
					? tax.breakdown || []
					: [];
				const employerBreakdown = ["Both", "Employer"].includes(tax.taxVariable.payer)
					? tax.breakdown || []
					: [];
				const employeeCalculation = ["Both", "Employee"].includes(tax.taxVariable.payer)
					? tax.calculation || []
					: [];
				const employerCalculation = ["Both", "Employer"].includes(tax.taxVariable.payer)
					? tax.calculation || []
					: [];
				// todo cater for new allowances that require replacing the temporary uuid

				console.log(
					"employeePays",
					taxName,
					["Both", "Employee"].includes(tax.taxVariable.payer),
					employeeContribution,
					tax,
				);

				/*if (employeeContribution == 0 && employerContribution == 0) {
            // do not show this
            return;
          }*/

				const employeeTax = _.find(employee.taxes, { taxName });
				if (employeeTax) {
					employeeTax.taxable = tax.earningsTaxed;
					employeeTax.employeeContribution += parseFloat(employeeContribution);
					employeeTax.employerContribution += parseFloat(employerContribution);
					employeeTax.employeeBreakdown = [...employeeTax.employeeBreakdown, ...employeeBreakdown];
					employeeTax.employerBreakdown = [...employeeTax.employerBreakdown, ...employerBreakdown];
					employeeTax.employeeCalculation = [...employeeTax.employeeCalculation, ...employeeCalculation];
					employeeTax.employerCalculation = [...employeeTax.employerCalculation, ...employerCalculation];
				} else {
					employee.taxes.push({
						taxName,
						taxable: tax.earningsTaxed,
						employeeContribution: employeeContribution ? parseFloat(employeeContribution) : 0,
						employerContribution: employerContribution ? parseFloat(employerContribution) : 0,
						employeeBreakdown,
						employerBreakdown,
						employeeCalculation,
						employerCalculation,
					});
				}
			});

			newState.payroll.employees[employeeIndex] = employee;

			return newState;
		}
		case Types.PAYROLL_REMOVE_ALLOWANCE: {
			let newState = { ...state };
			// let newState = _.cloneDeep(state);

			const { id, employeeID } = action.input;

			// console.log('PAYROLL_REMOVE_ALLOWANCE', id)

			const employeeIndex = newState.payroll.employees.findIndex(({ id }) => id == employeeID);
			const employee = { ...newState.payroll.employees.find(({ id }) => id == employeeID) };

			// console.log('PAYROLL_REMOVE_ALLOWANCEB4', employee.allowances)
			employee.allowances = _.reject(employee.allowances, { id: id });
			// console.log('PAYROLL_REMOVE_ALLOWANCEAF', employee.allowances)

			newState.payroll.employees[employeeIndex] = _.cloneDeep(employee);

			return newState;
		}
		case Types.PAYROLL_UPDATE_ALLOWANCE: {
			let newState = _.cloneDeep(state);

			const {
				id,
				employeeID,
				name,
				resetWeeklyPay,
				allowanceType,
				method,
				salary,
				salaryAllowance,
				salaryAllowanceAmount,
				input,
				leaveHours,
				basicRate,
				forceWeeklyPay,
				linked,
				isNew,
				paidBalance,
			} = action.input;

			const employeeIndex = newState.payroll.employees.findIndex(({ id }) => id == employeeID);
			const employee = { ...newState.payroll.employees.find(({ id }) => id == employeeID) };

			let allowance = _.find(employee.allowances, { id: id });

			if (!allowance) {
				allowance = {
					id: isNew ? id : uuidv4(),
					new: true,
					salary,
				};
				if (!employee.allowances) employee.allowances = [];
				employee.allowances.push(allowance);
			}

			if (!allowance.salary) {
				allowance.salary = salary;
			}

			allowance.name = name;
			allowance.salaryAllowance = salaryAllowance;
			allowance.allowanceType = allowanceType;
			allowance.input = input;
			allowance.method = method;
			allowance.linked = linked;
			allowance.paidBalance = paidBalance;
			allowance.leaveHours = leaveHours;
			allowance.forceWeeklyPay = forceWeeklyPay;
			allowance.updated = resetWeeklyPay ? undefined : true; // to flag that there are changes to save

			const salaryDetails = employee.salaries?.find(({ id }) => id == salary);

			// calculate the amount based on the type
			if (allowanceType) {
				const newAllowanceValues = calculateAllowanceAmount({
					state,
					input,
					allowanceType,
					baseHourlyRate: basicRate ? parseFloat(basicRate) : salaryDetails?.hourlySalaryAmount,
					salaryAllowanceAmount,
				});

				if (!allowance.isOvertime && salaryAllowanceAmount && allowance.method == "Hourly" && allowance.rate) {
					allowance.hourlyRate = salaryAllowanceAmount;
				}

				if (salaryAllowanceAmount && !allowance.salaryAllowance) {
					allowance.salaryAllowance = true;
				}

				allowance.amount = newAllowanceValues.amount;
				allowance.calculation = newAllowanceValues.calculation;
			}

			newState.payroll.employees[employeeIndex] = _.cloneDeep(employee);

			return newState;
		}
		case Types.PAYROLL_HOLIDAY_PAY_MODAL: {
			let newState = _.cloneDeep(state);

			newState.payroll.holidayPayModal = action.status
				? {
						allowance: action.allowance,
						agreementId: action.agreementId,
						payPeriodId: action.payPeriodId,
					}
				: undefined;

			return newState;
		}
		case Types.PAYROLL_UPLOAD_ALLOWANCE_MODAL: {
			let newState = _.cloneDeep(state);

			newState.payroll.uploadAllowanceModal = action.status ? action.status : undefined;

			return newState;
		}
		case Types.PAYROLL_HOLIDAY_PAY_WEEKS: {
			let newState = _.cloneDeep(state);

			newState.payroll.holidayPayModal.weeklyPay = action.weeklyPay;

			return newState;
		}
		case Types.PAYROLL_TOGGLE_TAXABLE_WEEK: {
			let newState = { ...state };
			// let newState = _.cloneDeep(state);

			const {
				employeeID,
				// payslipID,
				week,
			} = action;

			const employeeIndex = newState.payroll.employees.findIndex(({ id }) => id == employeeID);
			const employee = { ...newState.payroll.employees.find(({ id }) => id == employeeID) };

			const taxableWeeks = (employee.taxableWeeks && employee.taxableWeeks.filter((item) => item != week)) || [];
			if (!(employee.taxableWeeks && employee.taxableWeeks.includes(week))) {
				taxableWeeks.push(week);
			}
			employee.taxableWeeks = taxableWeeks;

			newState.payroll.employees[employeeIndex] = _.cloneDeep(employee);

			return newState;
		}
		case Types.PAYROLL_SAVING_ALL_PAYSLIP: {
			let newState = { ...state };

			const { department } = action;

			if (!newState.payroll.generating) {
				newState.payroll.generating = {};
			}

			newState.payroll.generating[department || "all"] = true;

			return newState;
		}
		case Types.PAYROLL_SAVED_ALL_PAYSLIP: {
			let newState = { ...state };

			const { department } = action;

			if (!newState.payroll.generating) {
				newState.payroll.generating = {};
			}

			newState.payroll.generating[department || "all"] = false;

			return newState;
		}
		case Types.PAYROLL_DEPARTMENT_EXPAND: {
			let newState = { ...state };

			const { department, expand } = action;

			if (!newState.payroll.departmentExpanded) {
				newState.payroll.departmentExpanded = {};
			}

			newState.payroll.departmentExpanded[department] = expand;

			return newState;
		}
		case Types.PAYROLL_GET_EMPLOYEES: {
			let newState = _.cloneDeep(state);

			newState.payroll.employees = action.payload.employees;
			newState.payroll.settings = action.payload.settings;

			newState.payroll.employees?.map?.((employee) => {
				employee.fullName = `${employee.employeeName} ${employee.employeeSurname}`;
				employee.salaryFrequency = employee.periodName;

				if (employee.department == "undefined") {
					delete employee.department;
				}

				// V2 will include payslip details right in
				if (employee.payslipId && !employee.payslip) {
					// payslip
					employee.payslip = action.payload.payslips.payslips.find(({ id }) => id == employee.payslipId);

					// taxableWeeks
					employee.taxableWeeks = employee?.payslip?.workingWeeks;
					console.log("employee?.payslip?.workingWeeks", employee?.payslip?.workingWeeks);

					// taxes
					employee.taxes = action.payload.payslips.taxes.filter(
						({ payslipId }) => payslipId == employee.payslipId,
					);
					// allowances
					employee.allowances = action.payload.payslips.allowances.filter(
						({ payslipId }) => payslipId == employee.payslipId,
					);

					// we know in some cases salaries would be already removed hence they would need to be updated .

					employee.allowances.map((allowance) => {
						if (allowance.salary && !employee.salaries?.find((sal) => sal.id == allowance.salary)) {
							// move this allowance to be used on current salary
							const allowanceDetails =
								_.find(
									[...state.allowances.allowanceList, ...(state.company.settings?.allowances || [])],
									{ id: allowance.allowanceType },
								) || _.find(state.overtimes.overtimeList, { id: allowance.allowanceType });
							const method = (allowanceDetails && allowanceDetails.method) || "Hourly"; //hourly default for OT

							// if (!allowance.salaryAllowance || ["Multiplier","Hourly","Commission"].includes(method)){

							allowance.salary = employee.salaries[0].id;
							allowance.updated = true; // this is needed to trigger an udpate

							if (allowance.salaryAllowance) {
								const salaryAllowance = employee.salaries[0].salaryAllowances.find(
									(s) =>
										s.allowanceType == allowance.allowanceType || s.type == allowance.allowanceType,
								);

								const salaryAllowanceAmount =
									salaryAllowance &&
									(salaryAllowance.salaryAllowanceAmount || salaryAllowance.amount);

								// calculate the amount based on the type as it may have changed
								const newAllowanceValues = calculateAllowanceAmount({
									state,
									input: allowance.input,
									allowanceType: allowance.allowanceType,
									baseHourlyRate: employee.salaries[0].hourlySalaryAmount,
									salaryAllowanceAmount,
								});

								if (
									!allowance.isOvertime &&
									salaryAllowanceAmount &&
									allowance.method == "Hourly" &&
									allowance.rate
								) {
									allowance.hourlyRate = salaryAllowanceAmount;
								}

								if (salaryAllowanceAmount && !allowance.salaryAllowance) {
									allowance.salaryAllowance = true;
								}
								allowance.amount = newAllowanceValues.amount;
								allowance.calculation = newAllowanceValues.calculation;
							}

							// }
						}
					});
				}

				if (employee.payslip) {
					employee.allowances = [];
					// transform allowances in format used
					employee?.payslip?.allowances.map((allowance) => {
						const allowanceId = allowance.id;

						// todo cater for new allowances that require replacing the temporary uuid

						// const employeeAllowance = _.find(employee.allowances,{id: allowanceId})
						const employeeAllowance = employee?.allowances?.find(({ id }) => id == allowanceId);

						console.log("employeeAllowance", employeeAllowance, employee.allowances, allowanceId);
						if (employeeAllowance) {
							employeeAllowance.id = allowanceId;
							employeeAllowance.updated = false;
							employeeAllowance.new = false;
							employeeAllowance.error = false;
						} else {
							// new allowance here
							// TODO test this scenario
							employee.allowances.push({
								...allowance,
								allowanceType: allowance.type,
								input: allowance.hours || allowance.quantity || allowance.input || allowance.amount, // TODO remove?
							});
						}
					});

					// taxableWeeks
					employee.taxableWeeks = employee?.payslip?.workingWeeks;

					// ensure we are creating a new object
					employee.taxes = [];

					employee?.payslip?.taxes?.map((tax) => {
						const taxName = `${tax.taxVariable.taxName}${
							tax.taxVariable.taxCategory ? ` ${tax.taxVariable.taxCategory}` : ``
						}`;

						const employeeContribution = ["Both", "Employee"].includes(tax.taxVariable.payer)
							? tax.amount
							: 0;
						const employerContribution = ["Both", "Employer"].includes(tax.taxVariable.payer)
							? tax.amount
							: 0;
						const employeeBreakdown = ["Both", "Employee"].includes(tax.taxVariable.payer)
							? tax.breakdown || []
							: [];
						const employerBreakdown = ["Both", "Employer"].includes(tax.taxVariable.payer)
							? tax.breakdown || []
							: [];
						const employeeCalculation = ["Both", "Employee"].includes(tax.taxVariable.payer)
							? tax.calculation || []
							: [];
						const employerCalculation = ["Both", "Employer"].includes(tax.taxVariable.payer)
							? tax.calculation || []
							: [];

						// todo cater for new allowances that require replacing the temporary uuid

						// if (employeeContribution == 0 && employerContribution == 0) {
						// 	// do not show this
						// 	return;
						// }

						const employeeTax = _.find(employee.taxes, { taxName });
						if (employeeTax) {
							employeeTax.taxable = tax.earningsTaxed;
							employeeTax.employeeContribution += parseFloat(employeeContribution);
							employeeTax.employerContribution += parseFloat(employerContribution);
							employeeTax.employeeBreakdown = [...employeeTax.employeeBreakdown, ...employeeBreakdown];
							employeeTax.employerBreakdown = [...employeeTax.employerBreakdown, ...employerBreakdown];
							employeeTax.employeeCalculation = [
								...employeeTax.employeeCalculation,
								...employeeCalculation,
							];
							employeeTax.employerCalculation = [
								...employeeTax.employerCalculation,
								...employerCalculation,
							];
						} else {
							employee.taxes.push({
								taxName,
								taxable: tax.earningsTaxed,
								employeeContribution: employeeContribution ? parseFloat(employeeContribution) : 0,
								employerContribution: employerContribution ? parseFloat(employerContribution) : 0,
								employeeBreakdown,
								employerBreakdown,
								employeeCalculation,
								employerCalculation,
							});
						}
					});
				}

				if (!employee.payslipId || !employee.payslip.gross) {
					const engagementDate = employee?.engagementDate;
					const terminationDate = employee?.terminationDate;

					const extraEngagementWeeks = [];
					let weeksBeforeTermination = null;

					const payPeriodDetails = action.payload.payPeriodDetails;

					if (engagementDate >= payPeriodDetails.periodStart) {
						let monday = startOfWeek(new Date(engagementDate), { weekStartsOn: 1 });

						let mondayString = format(monday, "yyyy-MM-dd");

						if (mondayString <= payPeriodDetails.periodStart) {
							extraEngagementWeeks.push(mondayString);
						}
					}

					if (
						terminationDate &&
						terminationDate >= payPeriodDetails.periodStart &&
						terminationDate <= payPeriodDetails.periodEnd
					) {
						let monday = startOfWeek(new Date(payPeriodDetails.periodStart), { weekStartsOn: 1 });

						let mondayOfEnagement = startOfWeek(new Date(engagementDate), { weekStartsOn: 1 });
						let mondayOfEnagementString = format(mondayOfEnagement, "yyyy-MM-dd");

						let mondayString = format(monday, "yyyy-MM-dd");

						weeksBeforeTermination = [];

						while (mondayString <= terminationDate) {
							if (
								mondayString >= payPeriodDetails.periodStart &&
								mondayString >= mondayOfEnagementString
							) {
								weeksBeforeTermination.push(mondayString);
							}

							monday = addWeeks(monday, 1);
							mondayString = format(monday, "yyyy-MM-dd");
						}
					}

					const isCasual = employee.salaries && employee.salaries.find((s) => s.casual == "yes");

					if (!employee.taxableWeeks) {
						employee.taxableWeeks = [];
					}

					if (employee.taxableWeeks.length == 0 && !employee?.payslip?.processedTimesheets) {
						extraEngagementWeeks.map((week) => {
							employee.taxableWeeks.push(week);
							// toggleTaxableWeek({week,employeeID});
						});

						if (weeksBeforeTermination) {
							weeksBeforeTermination.map((week) => {
								employee.taxableWeeks.push(week);
								// toggleTaxableWeek({week,employeeID});
							});
						} else {
							let mondayOfEnagement = startOfWeek(new Date(engagementDate), { weekStartsOn: 1 });
							let mondayOfEnagementString = format(mondayOfEnagement, "yyyy-MM-dd");

							payPeriodDetails.taxableWeeks.map((week) => {
								console.log("mondayOfEnagement", mondayOfEnagement);
								console.log("mondayOfEnagementweek", week);
								if (week >= mondayOfEnagementString) {
									employee.taxableWeeks.push(week);
								}
								// toggleTaxableWeek({week,employeeID});
								console.log("togglingWeeks2");
							});
						}
					}

					console.log("employee.taxableWeeks2", employee.fullName, employee.taxableWeeks);
				}

				// employee.basePay = "4347.12"
				// employee.grossPay = "4347.12"
				employee.expand = false;
				/*employee.taxes = [
          {
            name: "SSC",
            // name: "SSC",
            // name: "SSC",
          }
        ]
        employee.allowances = [
          {
            type: "156766",
            method: "hourly",
            value: 1,
            amount: -1
          },
          {
            type: "108170",
            method: "multiplier",
            value: 1,
            amount: -23.47
          }
        ]*/
			});

			newState.payroll.payPeriodDetails = action.payload.payPeriodDetails;

			newState.payroll.creditsUsed = action.payload.creditsUsed;

			if (newState.payroll.payPeriodDetails.payPeriods) {
				let defaultHours = 2080 / newState.payroll.payPeriodDetails.payPeriods;
				newState.payroll.payPeriodDetails.defaultHours = defaultHours;
			}

			return newState;
		}
		case Types.PAYROLL_UPDATING_PAY_PERIOD: {
			let newState = { ...state };

			newState.payroll = { ...state.payroll };

			newState.payroll.updatingPayPeriod = true;
			newState.payroll.payPeriodDetails = false;

			return newState;
		}
		case Types.PAYROLL_GETTING_LIST: {
			let newState = { ...state };
			newState.payroll.payrunLoading = action.payrunID;
			return newState;
		}
		case Types.PAYROLL_UPDATE_ID: {
			let newState = { ...state };

			if (newState.payroll.payPeriodDetails.id != action.payrunID) {
				newState.payroll = {
					reopenPayrollModalOpen: false,
					payrollPage: "main",
					generatingReports: false,
					departmentExpanded: {},
					payPeriodDetails: {},
					generating: {
						all: false,
					},
				};
			}
			newState.payroll.payPeriodDetails.id = action.payrunID;
			return newState;
		}
		case Types.PAYROLL_PAY_PERIOD: {
			let newState = _.cloneDeep(state);

			console.log("action", action);

			if (!newState.payroll) {
				newState.payroll = {};
			}

			const payPeriodDetails = action.payload.payPeriodDetails;

			newState.payroll.updatingPayPeriod = false;
			newState.payroll.payPeriodDetails = payPeriodDetails;

			const existingIndex = newState.payPeriods?.periods?.findIndex(({ id }) => id == payPeriodDetails.id);

			if (existingIndex > -1 && newState.payPeriods?.periods) {
				newState.payPeriods.periods[existingIndex] = payPeriodDetails;
			}

			if (newState.payroll?.payPeriodDetails?.payPeriods) {
				let defaultHours = 2080 / newState.payroll.payPeriodDetails.payPeriods;
				newState.payroll.payPeriodDetails.defaultHours = defaultHours;
			}

			return newState;
		}
		case Types.PAYROLL_PROCESS_TIMESHEETS_START: {
			let newState = _.cloneDeep(state);

			newState.payroll.processTimesheetSimulate = action.simulate;
			if (action.simulate) {
				newState.payroll.processTimesheetDepartment = action.department;
			}

			newState.payroll.processingTimesheets = true;

			return newState;
		}
		case Types.PAYROLL_PROCESS_TIMESHEETS_COMPLETE: {
			let newState = _.cloneDeep(state);

			newState.payroll.processingTimesheets = false;
			newState.payroll.processedTimesheets = action.payload;
			if (!newState.payroll.processTimesheetSimulate) {
				newState.payroll.processTimesheetDepartment = null;
			}

			console.log("processingComplete", action);

			return newState;
		}
		case Types.PAYROLL_PROCESS_TIMESHEETS_CLEAR: {
			let newState = _.cloneDeep(state);

			newState.payroll.processingTimesheets = false;
			newState.payroll.processedTimesheets = null;
			newState.payroll.processTimesheetDepartment = null;

			return newState;
		}
		case Types.PAYROLL_UNPROCESS_TIMESHEETS_MODAL: {
			let newState = _.cloneDeep(state);

			newState.payroll.unprocessPayslipModal = action.agreementID;

			return newState;
		}
		case Types.PAYROLL_UNPROCESS_LOADING: {
			let newState = _.cloneDeep(state);

			newState.payroll.unprocessTimesheetLoading = true;

			return newState;
		}
		case Types.PAYROLL_UNPROCESS_COMPLETED: {
			let newState = _.cloneDeep(state);

			// clear payslip data
			const employeeID = newState.payroll.unprocessPayslipModal;

			const employeeIndex = newState.payroll.employees.findIndex(({ id }) => id == employeeID);
			const employee = { ...newState.payroll.employees.find(({ id }) => id == employeeID) };

			// clear allowance values from a UI perspective
			// TODO only clear rule based ones (to remain consistent with backend)
			const payslip = {
				...employee.payslip,
			};

			payslip.basicHours = 0;
			payslip.ready = "no";
			payslip.processedTimesheets = "no";

			employee.payslip = payslip;
			newState.payroll.employees[employeeIndex] = employee;

			employee.allowances = employee.allowances?.map((allowance) => ({
				...allowance,
				amount: 0,
				input: 0,
			}));

			// newState.payroll.unprocessPayslipModal = action.agreementID
			newState.payroll.unprocessTimesheetLoading = false;
			newState.payroll.unprocessPayslipModal = null;

			return newState;
		}
		case Types.PAYROLL_PAY_TERMINATED_MODAL: {
			let newState = _.cloneDeep(state);

			console.log("action.payload", action.payload);
			// newState.payroll.unprocessPayslipModal = action.agreementID
			newState.payroll.processingPayTerminatedEmployeeModal = false;
			newState.payroll.showPayTerminatedEmployeeModal = action.show;

			return newState;
		}
		case Types.PAYROLL_PAY_TERMINATED_LOADING: {
			let newState = _.cloneDeep(state);

			console.log("action.payload", action.payload);

			newState.payroll.processingPayTerminatedEmployeeModal = true;

			return newState;
		}
		case Types.PAYROLL_CREATE_TERMINATED_PAYSLIP: {
			let newState = _.cloneDeep(state);

			newState.payroll.processingPayTerminatedEmployeeModal = false;
			newState.payroll.showPayTerminatedEmployeeModal = false;

			// TODO update list??

			return newState;
		}
		case Types.PAYROLL_RTI_GENERATING: {
			let newState = _.cloneDeep(state);

			newState.payroll.rtiGenerating = true;
			newState.payroll.rtiGenerated = false;

			return newState;
		}
		case Types.PAYROLL_RTI_GENERATING: {
			let newState = _.cloneDeep(state);

			newState.payroll.rtiGenerating = false;
			newState.payroll.rtiGenerated = true;

			return newState;
		}
		case Types.PAYROLL_TEST_IN_LIVE_MODAL: {
			let newState = _.cloneDeep(state);

			const testInLiveModal = action.show;
			newState.payroll.testInLiveModal = testInLiveModal;

			return newState;
		}
		case Types.PAYROLL_TEST_CONFIRMATION_MODAL: {
			let newState = _.cloneDeep(state);

			const testConfirmationModal = action.show;
			newState.payroll.testConfirmationModal = testConfirmationModal;

			return newState;
		}
		case Types.PAYROLL_UNSAVED_CHANGES_MODAL: {
			let newState = _.cloneDeep(state);
			newState.payroll.unsavedChangesModal = action.show;

			return newState;
		}
		case Types.PAYROLL_APPROVAL_OPEN_MODAL: {
			let newState = _.cloneDeep(state);

			newState.payroll.approvalModal = action.status;

			return newState;
		}
		case Types.PAYROLL_SET_LATE_SUBMIT_MODAL: {
			let newState = _.cloneDeep(state);

			newState.payroll.lateSubmitModal = { open: action.status };

			return newState;
		}
		default:
			return state;
	}
};

export default payrollRecuders;
